// extracted by css-extract-rspack-plugin
export default {"single_info":"single_info___12sMk","ul":"ul___uWokV","li":"li___Gjjuc"};